import { doc, getDoc, getFirestore } from 'firebase/firestore';

export const useFirebaseDocuments = () => {
  const db = getFirestore();

  const getDocData = async <T>(path: string) => {
    const docRef = doc(db, path);
    const snapshot = await getDoc(docRef);

    if (!snapshot.exists()) return null;

    const docData = snapshot.data();
    return {
      ...docData,
      id: snapshot.id,
      path: snapshot.ref.path
    } as T & { id: string, path: string };
  }

  return { getDocData };
};